import { VscTriangleLeft } from "react-icons/vsc";

const LongSelectedCone = ({ style }) => {
    return (
      <div style={style} className="admin__users-selelected-logo-container">
        <VscTriangleLeft className="admin__users-selelected-logo" />
      </div>
    );
  };

  export default LongSelectedCone